import { Component, OnInit, Inject, Input } from '@angular/core';
import { BaseComponent } from '@challenger6/vm-pattern-library/base/base.component';
import { LoginContentModel } from '@challenger6/vm-pattern-library/login/login-content.model';
import { AuthService } from '../../../services/auth.service';
import { Observable } from 'rxjs';
import { LoginService } from '../../../services/login.service';
import { LibConfig } from '../../../models/lib-config.model';
import { LIB_CONFIG } from '../../../lib-config';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../../../services/token.service';

@Component({
  selector: 'vm-header-login-nav',
  templateUrl: './header-login-nav.component.html',
  styleUrls: ['./header-login-nav.component.scss'],
})
export class HeaderLoginNavComponent extends BaseComponent implements OnInit {
  loginContent$: Observable<LoginContentModel>;
  assetsPrefix?: string;
  contentBaseUrl: string;
  signUpUrl = '/my-virgin-media/register';
  @Input() isAuthenticated: boolean;
  showLoginNav = false;

  constructor(
    private authService: AuthService,
    private tokenService: TokenService,
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(LIB_CONFIG) private config: LibConfig
  ) {
    super();
  }

  ngOnInit() {
    this.contentBaseUrl = this.config.strapiURL;
    this.assetsPrefix = this.config.assetsPath;
    this.loginContent$ = this.loginService.getLoginContent();
    this.setupCyTags('vm-login');

    const checkAuthentcation = setInterval(() => {
      this.isAuthenticated = this.authService.isAuthenticated();
      if (this.isAuthenticated) {
        clearInterval(checkAuthentcation);
      }
    }, 100);
    setTimeout(() => {
      clearInterval(checkAuthentcation);
    }, 500);
  }

  toggleLoginNav() {
    this.showLoginNav = !this.showLoginNav;
  }

  login() {
    this.authService.redirectToLogin();
  }

  logout() {
    this.tokenService.removeAuthTokenFromStorage();
    this.authService.logout();
    this.router.navigate(['/'], { relativeTo: this.route });
  }
}
